import { AppRouter } from "./routers/AppRouter";
import { useSelector } from "react-redux";
import { Menu } from "./components/ui/Menu";
import { ContentPage } from "./components/ui/ContentPage";

export const PortalClientes = () => {
  // const [language, setLanguage] = useState('en')
  // i18n.changeLanguage(language)
  // console.log(i18n.language)
  const { status } = useSelector((state) => state.auth);

  return status === "authenticated" ? (
    <>
      <Menu />
      <ContentPage />
    </>
  ) : (
    <AppRouter />
  );
};
